import styled from 'styled-components';

export const Secao = styled.section`
    background: var(--backgroundgrey-color);
    padding: 40px 0 30px;
`;

export const Titulo = styled.h1`
    font-size: 32px;
    line-height: 1.2em;
    color: var(--darkprimary-color);
    text-align: center;
    margin: 0 auto 10px;

    @media (max-width: 576px) {
        font-size: 26px;
    }
`;

export const Subtitulo = styled.p`
    font-size: 18px;
    line-height: 1.4em;
    color: var(--grey-color);
    text-align: center;
    max-width: 560px;
    margin: 0 auto 30px;
`;

export const Cartao = styled.div`
    background: var(--white-color);
    border-radius: 16px;
    box-shadow: 0 3px 12px var(--shadow-color);
    padding: 28px 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const CartaoTitulo = styled.h2`
    font-size: 22px;
    line-height: 1.2em;
    color: var(--primary-color);
    margin: 0 0 12px;
`;

export const CartaoTexto = styled.p`
    font-size: 16px;
    line-height: 1.5em;
    color: var(--darkprimary-color);
    margin: 0 0 16px;
`;

export const Acoes = styled.div`
    margin-top: auto;
`;

export const Passos = styled.ol`
    list-style: none;
    counter-reset: passo;
    padding: 0;
    margin: 0 0 16px;

    li {
        counter-increment: passo;
        position: relative;
        padding-left: 44px;
        margin-bottom: 16px;
        font-size: 16px;
        line-height: 1.5em;
        color: var(--darkprimary-color);
    }

    li::before {
        content: counter(passo);
        position: absolute;
        left: 0;
        top: 0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: var(--primary-color);
        color: var(--white-color);
        font-weight: bold;
        text-align: center;
        line-height: 30px;
    }
`;

export const Nota = styled.p`
    font-size: 14px;
    line-height: 1.4em;
    color: var(--grey-color);
    margin: 0;

    a {
        color: var(--primary-color);
        font-weight: bold;
    }
`;

export const Coluna = styled.div`
    margin-bottom: 20px;
`;
